import React from "react";
import notes from "../../../../assets/images/notes.svg";
import green from "../../../../assets/images/green.svg";
import red from "../../../../assets/images/red.svg";
import orange from "../../../../assets/images/orange.svg";
import CustomCard from "views/components/common/customcard/CustomCard";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const PageGridView = ({ extrated_data }) => {
  const language = useSelector((state) => state.common.currentLanguage);
  const { t } = useTranslation();
  const calculateTimeDifference = (timestamp) => {
    const timestampDate = new Date(timestamp);
    const currentDate = new Date();
    const timeDifference = currentDate - timestampDate;
    const hours = Math.floor(timeDifference / (1000 * 60 * 60));
    const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    const months = Math.floor(timeDifference / (1000 * 60 * 60 * 24 * 30));
    let translated;

    if (months === 1) {
      translated = months + t("month");
    } else if (months > 1) {
      translated = months + t("months");
    } else if (days === 1) {
      translated = days + t("day");
    } else if (days > 1) {
      translated = days + t("days");
    } else if (hours > 1) {
      translated = hours + t("hours");
    } else {
      translated = hours + t("hour");
    }

    if (language === "German" || language === "French") {
      translated = `${t('ago')} ${translated}`;
    } else {
      translated = `${translated} ${t('ago')}`;
    }
    
    return translated;
  };
  return (
    <>
      <div className="extractpdf-cardcontent ps-0 pt-1 pe-0">
        <div className="row">
          {extrated_data.map((item, index) => (
            <div
              className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb25"
              key={index}
            >
              <CustomCard
                id={item.id}
                dotblack="dot-black"
                imgicon={
                  item.extraction_status === "Good"
                    ? green
                    : item.extraction_status === "invalid_file_format" ||
                      item.extraction_status === "invalid_pet_invoice" ||
                      item.extraction_status === "extraction_issue"
                    ? red
                    : orange
                }
                notes={notes}
                notesimageclass="ms-2"
                notescontent={item.updation_status}
                notesclass={
                  item.updation_status === "not_yet_started"
                    ? "not-started-card"
                    : `${item.updation_status}-span`
                }
                cardtitle="d-inline-flex grid-card-title text-gray-e align-items-center mb3 mt3"
                spanbodycontent={calculateTimeDifference(item.extracted_at_cet)}
                spanclassname="text-gray-e text-wrap fs14 text-lowercase"
                pdfclassname="text-gray-e fs18 my-1 grid-card-pdfname"
                pdfname={item.file_name}
                dateclassname="d-md-inline-flex d-block text-gray-g grid-card-subtitle mt-0 mb-0"
                pagenumberclassname="text-gray-g grid-card-subtitle"
                pagenumber={
                  item.number_of_pages !== null
                    ? item.number_of_pages > 1
                      ? item.number_of_pages + " " + t("pages")
                      : item.number_of_pages + " " + t("page")
                    : null
                }
                recentlyUpdatedBy={item.assigned_user}
                extracted_time={item.last_modified_at_cet}
                version_history={item.version_history}
                sas_excel_link={item.sas_excel_link}
                sas_document_link={item.sas_document_link}
                notes_data={item.notes}
                file_name={item.file_name}
                extraction_status={item.extraction_status}
                recipient={
                  item.general_information
                    ? item.general_information["Policyholder Name"]
                    : ""
                }
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
export default PageGridView;
